'use strict';

const BaseModel = require('./base');

class SectionModel extends BaseModel {
  getTitle() {
    return this.get('title');
  }

  getPrice() {
    return this.get('price').amount;
  }

  getFormattedPrice() {
    return this.get('price').formattedAmount;
  }

  getPriceCurrencyCode() {
    return this.get('price').currencyCode;
  }

  getValue() {
    return this.get('value').amount;
  }

  getFormattedValue() {
    return this.get('value').formattedAmount;
  }

  getValueCurrencyCode() {
    return this.get('value').currencyCode;
  }

  getDiscount() {
    return this.get('discount');
  }

  getDiscountEnabled() {
    return this.get('discountEnabled');
  }

  getSavings() {
    return this.getValue() - this.getPrice();
  }

  getPriceTitle() {
    return this.getFormattedPrice() + this.getFormattedValue() + this.getTitle();
  }
}

module.exports = SectionModel;
